import { View, Platform, StyleProp, ViewStyle } from 'react-native'
import { colors } from '@ui/colors'
import Border from '@ui/effects/Border'
import { colorInner, colorOuter, PointProps } from './types'

const sizeOuter = Platform.select({
  default: 64,
  web: 72,
})

const sizeInner = Platform.select({
  default: sizeOuter / 4,
  web: 24,
})

const sizeDot = Platform.select({
  default: sizeInner / 4,
  web: 4,
})

export default function Point({ type, variant }: PointProps) {
  const sCenter =
    'flex flex-col items-center justify-center self-center rounded-full'

  const placement: StyleProp<ViewStyle> = {
    position: 'relative',
    top: -sizeOuter / 2,
    left: -sizeOuter / 2,
  }

  const borderWidth = 2

  return (
    <View
      className={sCenter}
      style={[
        placement,
        {
          width: sizeOuter,
          height: sizeOuter,
          borderWidth: borderWidth,
          borderColor: colorOuter[type][variant],
        },
      ]}
    >
      <Border
        style={{
          width: sizeInner + 2 * borderWidth,
          height: sizeInner + 2 * borderWidth,
          borderWidth: borderWidth,
          borderColor: colors.black,
          borderRadius: sizeInner,
        }}
      />
      <View
        className={sCenter}
        style={{
          width: sizeInner,
          height: sizeInner,
          backgroundColor: colorInner[type][variant],
          opacity: 0.5,
        }}
      />
      <View
        className={sCenter}
        style={{
          position: 'absolute',
          left: sizeOuter / 2 - sizeDot / 2 - borderWidth,
          top: sizeOuter / 2 - sizeDot / 2 - borderWidth,
          width: sizeDot,
          height: sizeDot,
          backgroundColor: colors.black,
        }}
      />
    </View>
  )
}
